import PropTypes from 'prop-types';

const alertPropType = PropTypes.shape({
  id: PropTypes.string,
  description: PropTypes.string,
  triggeredAlertEvent: PropTypes.shape({
    duration: PropTypes.string,
    triggerTimestamp: PropTypes.string,
    acknowledgementTimestamp: PropTypes.any,
    acknowledgementUser: PropTypes.any,
  }),
  timezone: PropTypes.string,
  channel: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    groupName: PropTypes.string,
    deviceName: PropTypes.string,
    deviceAssignmentId: PropTypes.string,
    deviceId: PropTypes.string,
    unit: PropTypes.any,
  }),
  lastReading: PropTypes.shape({
    formattedValue: PropTypes.string,
    formattedTimestamp: PropTypes.string,
  }),
  triggerCondition: PropTypes.shape({
    value: PropTypes.number,
    operator: PropTypes.string,
    formattedCondition: PropTypes.string,
    formattedValue: PropTypes.string,
  }),
  clearCondition: PropTypes.shape({
    value: PropTypes.number,
    operator: PropTypes.string,
    formattedCondition: PropTypes.string,
    formattedValue: PropTypes.string,
  }),
  temperatureScale: PropTypes.any,
  alertActionList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      metaData: PropTypes.shape({
        id: PropTypes.any,
        emailAddress: PropTypes.string,
        label: PropTypes.any,
      }),
      isPrimaryAction: PropTypes.bool,
      reminderInterval: PropTypes.any,
      maxReminders: PropTypes.any,
      quietTimeList: PropTypes.array,
      delay: PropTypes.any,
    }),
  ),
  hasAdvancedAlerting: PropTypes.bool,
  isDeviceAssignmentSuspended: PropTypes.bool,
  isAlertDeactivated: PropTypes.bool,
  isAcknowledged: PropTypes.bool,
  isFavoritedBySessionUser: PropTypes.bool,
  channelKey: PropTypes.string,
  alertCommentList: PropTypes.array,
  customTemplateList: PropTypes.array,
  additionalChannelKeys: PropTypes.array,
});

export default {
  alertPropType,
};
